const DIAS_SEMANA = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
];

// Devuelve "miércoles 22 de julio" a partir de un "YYYY-MM-DD" + N días corridos.
// Se construye la fecha por componentes (no new Date(string)) para evitar el corrimiento
// a UTC, que en Chile retrasaría el día un día.
export function formatFechaConOffset(ymd, offsetDias = 0) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd || '')) return null;
  const [anio, mes, dia] = ymd.split('-').map(Number);
  const fecha = new Date(anio, mes - 1, dia + offsetDias);
  return `${DIAS_SEMANA[fecha.getDay()]} ${fecha.getDate()} de ${MESES[fecha.getMonth()]}`;
}
